import { ChangeDetectorRef, Component } from '@angular/core';
import { IdmApiService, UserUtilityService } from 'src/app/services';
import { Subject, takeUntil } from 'rxjs';
import { Approval } from 'src/app/Modules/settings/models/common/setting-area.model';

@Component({
    selector: 'app-approvals-content',
    templateUrl: './approvals-content.component.html',
    styleUrls: ['./approvals-content.component.scss'],
})
export class ApprovalsContentComponent {
    ApprovalList: Approval[] = [];
    pendingApprovalList: Approval[];
    completedApprovalList: Approval[];
    isSubscribe: Subject<any> = new Subject<any>();
    isRequestShow: boolean = false;
    isCompletedShow: boolean = false;
    constructor(
        private user_utility: UserUtilityService,
        private idmApiService: IdmApiService,
        private cd: ChangeDetectorRef
    ) {}
    async ngOnInit(): Promise<void> {
        this.LoadApprovals();
    }
    LoadApprovals() {
        this.idmApiService
            .getApprovals()
            .pipe(takeUntil(this.isSubscribe))
            .subscribe(
                (res: any) => {
                    this.ApprovalList = null;
                    this.completedApprovalList = null;
                    this.cd.detectChanges();
                    this.ApprovalList = res.response;
                    this.pendingApprovalList = this.ApprovalList.filter((m) => m.state?.key == 1);
                    this.isRequestShow = true;
                    this.completedApprovalList = this.ApprovalList.filter((m) => m.state?.key != 1);
                    this.isCompletedShow = true;

                    this.cd.detectChanges();
                },
                () => {}
            );
    }
    updateList(data: boolean) {
        if (data) {
            this.LoadApprovals();
        }
    }
    ngOnDestroy(): void {
        this.isSubscribe.unsubscribe();
        // this.isSubscribe.next(null);
    }
}
